

<div id="{{LP_CREATE_EVENT_ID}}" [formGroup]="form">

  <div [@collapse]="!typeFormCollapsed" class="overflow-hidden">
    <h3 class="text-blue-900 m-0">
      Vypište svůj první kurz ještě dnes
    </h3>

    <p class="text-color-secondary mb-5">
      Za 10 minut můžete začít sbírat registrace. Začněte zadáním názvu:
    </p>
  </div>

  <div class="p-inputgroup">
    <input
      #titleInput
      type="text"
      (focus)="onTitleInputFocus()"
      (blur)="onTitleInputBlur()"
      pInputText
      placeholder=""
      formControlName="title"
      class="p-inputtext-lg">
    <button
      id="lp.signup.start"
      *ngIf="showTitleContinue"
      (click)="onTitleContinue()"
      pButton
      label="Uložit a pokračovat"
      class="p-button-success">
    </button>
  </div>


  <div [@collapse]="typeFormCollapsed">

    <h4 class="text-blue-900 my-3">
      Vyberte o jakou akci se jedná
    </h4>

    <app-event-type-radio-input [FC]="form.controls.format"></app-event-type-radio-input>

  </div>

  <div [@collapse]="emailFormCollapsed">

    <h4 class="text-blue-900 my-3">
      Na jaký e-mail zařídíme Váš admin účet?
    </h4>

    <input type="text" pInputText formControlName="email" placeholder="Zadejte svůj e-mail" class="p-inputtext-lg w-full mb-4">

    <button
      id="lp.signup.createevent"
      (click)="onSubmit()"
      [loading]="sending"
      [disabled]="sending"
      pButton
      label="Vypsat událost"
      class="p-button-success w-full">
    </button>

  </div>



</div>
